import React from 'react'
import { FormattedMessage } from 'react-intl';

const TableHead = (props) => {
  return (
    <thead className='thead-light'>
      <tr>
        <th
          className="sort"
          data-sort="id"
          scope="col"
          onClick={() => props.applySort('id')}
        >
          <FormattedMessage
            id="pages.documents.documentList.document_id_col" />
        </th>
        <th
          className="sort"
          data-sort="size"
          scope="col"
          onClick={() => props.applySort('created_at')}
        >
          <FormattedMessage
            id="pages.documents.documentList.document_created_at_col" />
        </th>
        <th
          className="sort"
          data-sort="name"
          scope="col"
          onClick={() => props.applySort('name')}
        >
          <FormattedMessage
            id="pages.documents.documentList.document_name_col" />
        </th>
        <th
          className="sort"
          data-sort="user_id"
          scope="col"
          onClick={() => props.applySort('user_id')}
        >
          <FormattedMessage
            id="pages.documents.documentList.document_user_id_col" />
        </th>
        <th
          className="sort"
          data-sort="package_group_id"
          scope="col"
          onClick={() => props.applySort('package_group_id')}
        >
          <FormattedMessage
            id="pages.documents.documentList.document_package_group_id_col" />
        </th>
        <th
          className="sort"
          data-sort="organization_id"
          scope="col"
          onClick={() => props.applySort('organization_id')}
        >
          <FormattedMessage
            id="pages.documents.documentList.document_organization_id_col" />
        </th>
        <th
          className="sort"
          data-sort="status"
          scope="col"
          onClick={() => props.applySort('status')}
        >
          <FormattedMessage
            id="pages.packages.packageList.package_status" />
        </th>
        <th
          scope="col"
        >
          <FormattedMessage
            id="components.pages.clients.clientsTable.table.actions" />
        </th>
      </tr>
    </thead>
  )
}

export { TableHead }
